import * as Yup from 'yup';

export const hsdVsAvgConsumptionReportFormModel = {
  formId: 'hsdVsAvgConsumptionReportConfig',
  formField: {
    startTime: {
      name: 'month_year',
      label: 'Select Month & Year',
      type: 'date',
      errorMsg: 'Month and year is required!'
    }
  }
};

const {
  formField: {
    startTime
  }
} = hsdVsAvgConsumptionReportFormModel;

export const hsdVsAvgConsumptionReportInitialValues = {
  [startTime.name]: ''
};

export const hsdVsAvgConsumptionReportValidationSchema = Yup.object().shape({
  [startTime.name]: Yup.date().nullable().required(startTime.errorMsg)
});

export const hsdVsAvgConsumptionReportFormConfig = {
  formModel: hsdVsAvgConsumptionReportFormModel,
  initialValues: hsdVsAvgConsumptionReportInitialValues,
  validation: hsdVsAvgConsumptionReportValidationSchema
};
